import type { FC } from 'react';

import { Button, ButtonVariant } from '@catalyze/ui';

import { ToastContainer, ToastButtonsContainer } from './styled';

interface IToast {
    onCancel: () => void;
    onSave: () => void;
}

export const Toast: FC<IToast> = ({ onSave, onCancel }) => (
    <ToastContainer>
        <b>Unsaved changes</b>
        <ToastButtonsContainer>
            <Button variant={ButtonVariant.SECONDARY} onClick={onCancel}>
                Cancel
            </Button>
            <Button variant={ButtonVariant.PRIMARY} onClick={onSave}>
                Save
            </Button>
        </ToastButtonsContainer>
    </ToastContainer>
);
